import invariant from 'tiny-invariant';
import {
  BaseStorageItem,
  ServiceProvider,
  StorageItemMetadata,
  UPLOADCAM_FOLDER_MIME,
} from '@uploadcam/common';

export class GoogleDriveItem extends BaseStorageItem {
  constructor(private readonly driveFile: gapi.client.drive.File) {
    super();
  }

  public get provider(): ServiceProvider {
    return ServiceProvider.Google;
  }

  public get id(): string {
    invariant(this.driveFile.id, `Google Drive 'item.id' must be defined.`);

    return this.driveFile.id;
  }

  public get parentId(): string | undefined {
    // TODO: handle multiple parents
    if (this.driveFile.parents && this.driveFile.parents.length > 0) {
      return this.driveFile.parents[0];
    }

    return undefined;
  }

  public get driveId(): string | undefined {
    return this.driveFile.driveId;
  }

  public get allowsSubfolderCreation(): boolean {
    return this.isFolder;
  }

  public get isVirtual(): boolean {
    return false;
  }

  private mapFolderMime(mime: string): string {
    return mime === 'application/vnd.google-apps.folder' ? UPLOADCAM_FOLDER_MIME : mime;
  }

  public get mime(): string {
    if (this.isShortcut) {
      invariant(
        this.driveFile.shortcutDetails,
        `Google Drive 'item.shortcutDetails' must be defined.`,
      );
      invariant(
        this.driveFile.shortcutDetails.targetMimeType,
        `Google Drive 'item.shortcutDetails.targetMimeType' must be defined.`,
      );

      return this.mapFolderMime(this.driveFile.shortcutDetails.targetMimeType);
    } else {
      invariant(this.driveFile.mimeType, `Google Drive 'item.mimeType' must be defined.`);

      return this.mapFolderMime(this.driveFile.mimeType);
    }
  }

  public get name(): string {
    invariant(this.driveFile.name, `Google Drive 'item.name' must be defined.`);

    return this.driveFile.name;
  }

  public get lastModified(): Date | undefined {
    return this.driveFile.modifiedTime ? new Date(this.driveFile.modifiedTime) : undefined;
  }

  public get isShortcut(): boolean {
    return this.driveFile.mimeType === 'application/vnd.google-apps.shortcut';
  }

  public get metadata(): StorageItemMetadata {
    return {};
  }

  public get size(): number | undefined {
    if (this.isFile && this.driveFile.size) {
      return Number(this.driveFile.size);
    }

    return undefined;
  }
}
